import axios from "axios";
import Vue from 'vue';
import Vuex from 'vuex';
import vClickOutside from 'v-click-outside';

import admin from './modules/admin'
import dailyCounts from './modules/dailyCounts'
import login from './modules/login'
import loading from "./modules/loading";
import profile from "./modules/profile";
import profileReview from "./modules/profileReview";
import poiSets from "./modules/poiSets";
import notifications from "./modules/notifications";
import acornCodes from "./modules/acornCodes";
import router from "../router";

const VUE_APP_BACKEND_URL = process.env.VUE_APP_BACKEND_URL;

Vue.use(Vuex);
Vue.use(vClickOutside);

const store = new Vuex.Store({
  state: {
    accessToken: null,
    inst: axios.create({
      baseURL: VUE_APP_BACKEND_URL,
    }),
  },
  mutations: {
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken;
      state.inst.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    },
    resetAccessToken(state) {
      state.inst.defaults.headers.common['Authorization'] = undefined;
    },
  },
  modules: {
    acornCodes,
    admin,
    dailyCounts,
    login,
    loading,
    profile,
    profileReview,
    poiSets,
    notifications
  }
});

const MAX_REQUESTS_COUNT = 3;
const INTERVAL_MS = 10;
let PENDING_REQUESTS = 0;

store.state.inst.interceptors.request.use(
  function (request) {
    // noinspection JSUnresolvedVariable
    if (request.backgroundRequest) {
      store.dispatch('startBackgroundLoading');
    } else {
      store.dispatch('startForegroundLoading');
    }

    return new Promise((resolve) => {
      let interval = setInterval(() => {
        if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
          PENDING_REQUESTS++
          clearInterval(interval)
          resolve(request)
        }
      }, INTERVAL_MS)
    })
  },
);

store.state.inst.interceptors.response.use(
  function (response) {
    // noinspection JSUnresolvedVariable
    if (response.config.backgroundRequest) {
      store.dispatch('finishBackgroundLoading');
    } else {
      store.dispatch('finishForegroundLoading');
    }

    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
  },
  function (error) {
    // noinspection JSUnresolvedVariable
    if (error.config.backgroundRequest) {
      store.dispatch('finishBackgroundLoading');
    } else {
      store.dispatch('finishForegroundLoading');
    }

    if (error.response.status === 401) {
      store.state.accessToken = null;
      router.push({ name: "Login" });
    }

    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error);
  }
);

export default store;
